import styled from "styled-components";

export const NotificationTitle = styled("span")`
    font-weight: bold;
    margin-right: 0.3em;
`;
